module.exports = __webpack_public_path__ + "assets/images/amira.3cf18340640f60884db719eeeb94b7e9.svg";